import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { fetch_all, fetch_one } from '../../lib/server_helper';
import { loginAtom } from '../../lib/auth';

import WarningIcon from '@mui/icons-material/Warning';

import {
  Divider,
  Grid
} from '@mui/material';

import {
  Dt,
  ErrorBox,
  StyledButton,
  StyledSelect,
  Typography
} from '../../components/interface';
import { PickersCompanyPicker } from '../../components/pickers/CompanyPicker';
import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import { Company } from '../../models/Company';
import { Project } from '../../models/Project';

type Props = {};

export const SpecialMemoq: FunctionComponent<Props> = () => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);

  const [companyId, setCompanyId] = useState<number>();
  const [projectIntId, setProjectIntId] = useState<number>();
  const [projectExtId, setProjectExtId] = useState<number>();
  const [projects, setProjects] = useState<Project[]>([]);
  const [saveLoader, setSaveLoader] = useState<boolean>(false);

  // Settings

  useEffect(() => {
    searchProjects();
  }, [companyId]);

  const searchProjects = () => {
    if (!!companyId) {
      fetch_all<Project>('/nl/v3/objects/fetch_all', {
        object: 'project',
        fields: ['id', 'name'],
        per_page: 100,
        page: 0,
        order: "name ASC",
        filter: {
          search: '',
          advanced: {
            fallback: '',
            company_id: companyId
          }
        }
      }, (obs, complete_data) => {
        setProjects(obs);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    } else {
      
    }
  };







  const setMemoq = () => {
    setSaveLoader(true);

    fetch_one<Company>('/nl/v3/objects/custom_action', {
      object: 'company',
      class_action: 'custom_api_init_memoq',
      id: companyId,
      int_id: projectIntId,
      ext_id: projectExtId
    }, (ob, complete_data) => {
      setSaveLoader(false)
      setCompanyId(undefined);
      setProjectIntId(undefined);
      setProjectExtId(undefined);
    }, (z) => {
      setServerErrorSnackOpen(true);
    }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
  };







  return <>
    <Grid container spacing="8">
      <Grid item xs={12}>
        <ErrorBox
          type="error"
          noTitle
          title="Caution!"
          text="Using these special-admin-only functions can break existing projects. Use with care!<br/><br/>These are only available to admins with the 'special permissions' checkbox."
          icon={<WarningIcon sx={{
            height: '60px',
            width: '60px',
            color: theme.palette.secondary.main
          }} />}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3">Set 2 projects as MEMOQ questionnaires</Typography>
        <Typography variant="body1">&lt;some explanation&gt;</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <PickersCompanyPicker
          value={companyId?.toString() || ''}
          onChange={(ob) => {
            setCompanyId(parseInt(ob, 10));
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Project - INTERNAL"
          value={projectIntId?.toString() || ''}
          id='projectIntId'
          onChange={(v) => {
            setProjectIntId(parseInt(v, 10));
          }}
          list={projects.map(project => ({id: (project.id || '').toString(), name: (project.name || '')}))}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Project - EXTERNAL"
          value={projectExtId?.toString() || ''}
          id='projectExtId'
          onChange={(v) => {
            setProjectExtId(parseInt(v, 10));
          }}
          list={projects.map(project => ({id: (project.id || '').toString(), name: (project.name || '')}))}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{marginTop: 1, marginBottom: 2}} />

        {<StyledButton
          label={t("public.buttons.save")}
          id='save'
          disabled={!projectIntId || !projectExtId || !companyId}
          loading={saveLoader}
          contained
          onClick={(v) => {
            setMemoq();
          }}
          sx={{marginLeft: 1}}
        />}
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{marginTop: 1, marginBottom: 2}} />

        <Typography variant="body1" sx={{fontStyle: 'italic', fontSize: '0.8rem'}}>
          This action will clear the 2 projects of existing questions and answers and will create the MEMOQ questions. Afterwards it will create an admin report and an organiser report.<br/>
          You will need to:<br/><ul>
            <li>Add locations to the INTERNAL project</li>
            <li>Add <u>the exact same</u> locations to the EXTERNAL project</li>
            <li>Double-check the questions</li>
            <li>Double-check the report settings (and maybe rename them)</li>
            <li>Double-check the invitation (system) email_templates for both the INTERNAL and EXTERNAL invites</li>
            <li>Double-check the 6 infopages in both projects (or remove the link to the pages in the questions)</li>
            <li>Invite organisers to the company</li>
          </ul>
        </Typography>
      </Grid>

    </Grid>
    {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
  </>;
}
